import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationType, Notification } from '@lsq-frontend/remote-services/enterprise/common';
import { Color, DateFormat, NotificationActionButtonDisplayEnum } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';

@Component({
    selector: 'notification',
    template: `
        <div class="lsq-notification">
            <div class="lsq-notification-top-row">
                <span class="title">{{ titleText }}</span>
                <span class="close" *ngIf="!notification.isPersistent">
                    <lsq-icon
                        aria-hidden="true"
                        [type]="icons.Close"
                        [color]="colors.GrayDark"
                        [hoverColor]="colors.GrayDarkest"
                        [height]="10"
                        [width]="10"
                        (click)="emitCloseNotification()"
                    >
                    </lsq-icon>
                </span>
            </div>
            <div class="lsq-notification-middle-row">
                <span class="text">{{ notificationText }}</span>
            </div>
            <div class="lsq-notification-bottom-row">
                <span>{{ notification.createdAt | date: dateFormat.DateTime }}</span>
                <a class="lsq-notification-action" (click)="emitActionNotification()">
                    {{ actionText }}
                </a>
            </div>
        </div>
    `,
    styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
    @Input() public notification: Notification;
    @Output() public closeNotification = new EventEmitter<Notification>();
    @Output() public notificationAction = new EventEmitter<Notification>();

    public icons = Icons;
    public colors = Color;
    public notificationType = NotificationType;
    public notificationActionDisplayEnum = NotificationActionButtonDisplayEnum;
    public titleText: string;
    public notificationText: string;
    public actionText: string;
    public dateFormat = DateFormat;

    constructor(public datePipe: DatePipe) {}

    public ngOnInit(): void {
        const typeKey = this.notificationType[this.notification.type];
        this.actionText = this.notificationActionDisplayEnum[typeKey];

        if (this.notification.type === this.notificationType.Survey) {
            this.titleText = `Survey: ${this.notification.title}`;
            this.notificationText = 'Take the latest survey to let us know what you think.';
        } else {
            this.titleText = this.notification.title;
            this.notificationText = this.notification.text;
        }
    }

    public emitActionNotification(): void {
        this.notificationAction.emit(this.notification);
    }

    public emitCloseNotification(): void {
        this.closeNotification.emit(this.notification);
    }
}
